// Function to handle smooth scrolling and updating history
function smoothScrollToElement(href) {
  const targetElement = document.querySelector(href);
  if (targetElement) {
    window.scroll({
      top: targetElement.getBoundingClientRect().top + window.scrollY - 120,
      behavior: 'smooth'
    });
    history.pushState(null, '', href);
  }
}
